import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-television-icon]',
  template: `
    <svg:path
      d="M4 4C3.44772 4 3 4.44771 3 5V15C3 15.5523 3.44772 16 4 16H20C20.5523 16 21 15.5523 21 15V5C21 4.44772 20.5523 4 20 4H4ZM1 5C1 3.34314 2.34315 2 4 2H20C21.6569 2 23 3.34315 23 5V15C23 16.6569 21.6569 18 20 18H14.8508L17.6247 20.2191C18.056 20.5641 18.1259 21.1934 17.7809 21.6247C17.4359 22.056 16.8066 22.1259 16.3753 21.7809L12 18.2806L7.62469 21.7809C7.19343 22.1259 6.56414 22.056 6.21913 21.6247C5.87412 21.1934 5.94404 20.5641 6.37531 20.2191L9.14922 18H4C2.34315 18 1 16.6569 1 15V5Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelevisionIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
